import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';

import { BUTTON, Button } from 'components/common/Button/Button';
import styles from './ReportDialogs.scss';

const ReportDialogAction = ({ reportLabel, canSubmitReport, toggleDialog, loadReport }) => {
    const downloadReport = () => {
        loadReport();
        toggleDialog();
    };

    return (
        <DialogActions className={styles.dialogAction} data-cy="ReportDialogAction">
            <Button
                className={styles.btnOutline}
                onClick={toggleDialog}
                bgcolor={BUTTON.BGCOLOR.CLEAR}
                color={BUTTON.COLOR.GREY}
                data-cy="ReportDialogAction-Cancel"
            >
                Cancel
            </Button>
            <Button
                onClick={downloadReport}
                bgcolor={BUTTON.BGCOLOR.ORANGE}
                color={BUTTON.COLOR.WHITE}
                disabled={!canSubmitReport}
                data-cy="ReportDialogAction-reportLabel"
            >
                {reportLabel}
            </Button>
        </DialogActions>
    );
};

export default ReportDialogAction;
